// extracted by mini-css-extract-plugin
export default {"header":"logo_header_header__s9pSw","container":"logo_header_container__9bz4b"};